import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import ProviderFields from './ProviderFields';
import { required } from '../../Helpers/validators';
import { FOOD_VENDOR, GOODS_VENDOR } from '../../Constants/constants';

const AdditionalQuestions = ({
  provider,
  duration,
  fieldArrayName,
  fieldArrayCount,
  frequencyFieldName,
  frequencyFieldValue,
  alertTrigger,
  setAlertTrigger,
}) => {
  let providerText = '';
  let providerName = 'Vendor';

  if (provider === GOODS_VENDOR) {
    providerText = 'vendor selling goods';
  } else if (provider === FOOD_VENDOR) {
    providerText = 'vendor selling food and/or beverages';
  } else {
    providerText = provider;
    providerName = provider;
  }

  return (
    duration > 1 &&
    fieldArrayCount > 0 &&
    fieldArrayCount < 7 && (
      <div className="mb-2">
        <div className="label mb-2">
          {`How many days of the event will each uninsured ${providerText} be on-site?`}
        </div>

        <div className="form-group form-row">
          <div className="col-auto my-auto">
            <div className="btn-group btn-group-toggle mr-3">
              <label
                className={`btn btn-outline-primary ${
                  frequencyFieldValue === 'everyday' ? 'active' : ''
                }`}
                htmlFor={`${frequencyFieldName}.everyday`}
              >
                <Field
                  name={frequencyFieldName}
                  id={`${frequencyFieldName}.everyday`}
                  component="input"
                  type="radio"
                  value="everyday"
                  validate={[required]}
                  onChange={() => setAlertTrigger(false)}
                />
                Everyday
              </label>
            </div>
            <div className="btn-group btn-group-toggle">
              <label
                className={`btn btn-outline-primary ${
                  frequencyFieldValue === 'somedays' ? 'active' : ''
                }`}
                htmlFor={`${frequencyFieldName}.somedays`}
              >
                <Field
                  name={frequencyFieldName}
                  id={`${frequencyFieldName}.somedays`}
                  component="input"
                  type="radio"
                  value="somedays"
                  validate={[required]}
                />
                Only some days
              </label>
            </div>
          </div>
        </div>

        {frequencyFieldValue === 'somedays' && (
          <div className="mb-4">
            <div className="d-flex">
              <div className="col-sm-6 p-0 mr-3 mb-1 font-weight-bold">
                {providerName}
              </div>
              <div className="col-sm-2 p-0 mb-1 font-weight-bold">Days</div>
            </div>
            <FieldArray
              name={fieldArrayName}
              component={ProviderFields}
              fieldCount={fieldArrayCount}
              nameFieldPlaceholderPrefix={providerName}
              props={{
                duration,
                alertTrigger,
                setAlertTrigger,
              }}
            />
          </div>
        )}
      </div>
    )
  );
};

AdditionalQuestions.propTypes = {
  provider: PropTypes.string.isRequired,
  duration: PropTypes.number.isRequired,
  fieldArrayName: PropTypes.string.isRequired,
  fieldArrayCount: PropTypes.number.isRequired,
  frequencyFieldName: PropTypes.string.isRequired,
  frequencyFieldValue: PropTypes.string.isRequired,
  alertTrigger: PropTypes.bool.isRequired,
  setAlertTrigger: PropTypes.func.isRequired,
};

export default AdditionalQuestions;
